import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

import { PendType } from "types";

export type AlertPendModalProps = {
	show: boolean;
	onHide: () => void;
	pends?: PendType[];
	to?: string;
};

const AlertPendModal: React.FC<AlertPendModalProps> = ({
	pends = [],
	show,
	onHide,
	to = "pend-details",
}) => {
	const onLinkClick = () => {
		onHide?.();
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		});
	};
	return (
		<Modal
			show={show}
			onHide={onHide}
			animation={false}
			centered
			scrollable
		>
			<Modal.Header closeButton>
				<Modal.Title as="h6" className="text-center">
					Please close pends before continuing:
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="d-flex justify-content-center">
				<ol>
					{pends?.map((pend, index) => {
						return (
							<li key={index} className="mb-3">
								<Link
									to={to}
									onClick={onLinkClick}
								>{`Pend - ${pend?.number} Details`}</Link>
							</li>
						);
					})}
				</ol>
			</Modal.Body>
		</Modal>
	);
};

export default AlertPendModal;
